"use client"

import { Skeleton } from "antd";
import { FC } from "react";

type ButtonSearchHotelsSkeletonProps = {
  size?: 'small' | 'default'
}

const ButtonSearchHotelsSkeleton: FC<ButtonSearchHotelsSkeletonProps> = ({ size }) => {
  const isSmall = size === 'small'

  return (
    <Skeleton.Button
      active
      size="large"
      className={isSmall ? "home__searching--hero-search-btn" : "home__searching--button-search"}
      block={!isSmall}
      style={isSmall ? { height: '4.4rem', minWidth: '4.4rem', width: '4.4rem' } : {}}
    />
  );
}

export default ButtonSearchHotelsSkeleton;